import { wrap } from '../../utils/globalUtils'
import type { WelcomeHookProps } from './types'
import { useWelcome } from './hooks'
import { WelcomeView } from './WelcomeView'
import type { FC } from 'react'

const Welcome: FC<WelcomeHookProps> = wrap(WelcomeView, useWelcome)

export default Welcome
